import * as React from "react"

import { BaseCellProps } from "../shared/BaseCell"

import { Content, StyledCell } from "./Styles"

interface StaticCellProps extends BaseCellProps {
  value: string
  linethrough?: boolean
}

const StaticCell = ({ value, linethrough = false, ...cellProps }: StaticCellProps): JSX.Element => {
  return (
    <StyledCell {...cellProps}>
      <Content linethrough={linethrough}>{value}</Content>
    </StyledCell>
  )
}

export default StaticCell
